export default function FlightsTypeaheadController(
    $scope,
    $controller
) {
    'ngInject';

            $controller('TypeaheadBaseController', {
                $scope,
                cfg: {
                    searchLocationsUrl: '/staticdata/SearchAirportsAlternate',
                },
            });
}



// WEBPACK FOOTER //
// ./src/app/modules/flights/controllers/flightsTypeaheadCtrl.js